import { useEffect } from "react";

import PrimaryHomeHolder from "../../components/home/primary_holder/primary_holder.component.jsx";
import HomepageSC from "./homepage.styles.js";
import AppLogo from "../../assets/app_logo.png";
import FloatingBackground from "../../components/home/primary_holder/floating_background.jsx";

const Homepage = () => {
    useEffect(() => {
        try {
            const ua = window.navigator.userAgent;
            const isIOS = /iPhone|iPad|iPod/i.test(ua);

            // This regex checks for common in-app browser strings (LinkedIn, FB, IG, etc.)
            // and ensures we aren't already in the "real" Safari or a Chrome-iOS shell.
            const isInAppBrowser = isIOS && (
                ua.includes('LinkedInApp') ||
                ua.includes('FBAN') ||
                ua.includes('FBAV') ||
                ua.includes('Instagram') ||
                ua.includes('Twitter') ||
                (!ua.includes('Safari') && ua.includes('Mobile'))
            );

            if (isInAppBrowser && !window.location.search.includes('visit=true')) {
                const currentUrl = window.location.href;
                const connector = currentUrl.includes('?') ? '&' : '?';

                const safariRedirect = `x-safari-${currentUrl}${connector}visit=true`;

                window.location.replace(safariRedirect);
            }
        } catch (error) {
            console.error(error);
        }
    }, []);
    return <HomepageSC>
        <FloatingBackground />
        <Toolbar />
        <Footer />
        <PrimaryHomeHolder />
    </HomepageSC>
}

const Toolbar = () => {
    return <div className="toolbar">
        <img src={AppLogo} alt='anahex' className="app-logo" />
    </div>
}


const Footer = () => {
    return (
        <footer className="app-footer">
            <div className="app-container">
                <div className="app-logo">
                    <img src={AppLogo} alt="Anahex" />
                </div>

                <p className="app-tagline">
                    Upskill without deadlines, stress, or boundaries. Built for those who choose progress every day — learn at your own pace, in your own time, with complete freedom to grow consistently and intentionally.
                    Join Now.
                </p>

                <p className="app-copy">
                    © 2026 Anahex. All rights reserved.
                </p>

                <div className="app-links">
                    <a href="/privacy">Privacy Policy</a>
                    <a href="/terms">Terms of Service</a>
                </div>
            </div>
        </footer>
    );
};

export default Homepage;